import { Conditional, WarningToolTip } from 'components/pcc-components';
import styles from '../../customer-account.module.scss';
import { useTranslations } from 'next-intl';
import { EquipmentListProps } from '../../types';
import cx from 'classnames';
import { useServiceInsights } from 'hooks/use-service-insights';

export const ServiceInsightIconWrapper = ({
  equipment,
  selectedEquipment,
  userDetail,
  serviceInsights
}: Readonly<EquipmentListProps>) => {
  const t = useTranslations();
  const { serviceInsightEnabled } = useServiceInsights(
    serviceInsights,
    equipment,
    userDetail.isCspUser
  );

  return (
    <Conditional test={serviceInsightEnabled}>
      <div
        className={cx('position-absolute overflow-auto', {
          [styles['equipment-list__selected_insights']]:
            equipment.uniqueIndex === selectedEquipment?.uniqueIndex,
          [styles['equipment-list__unselected_insights']]: !(
            equipment.uniqueIndex === selectedEquipment?.uniqueIndex
          )
        })}
      >
        <WarningToolTip
          isToolTip
          toolTipDescription={t('SERVICE_INSIGHTS_AVBL')}
        />
      </div>
    </Conditional>
  );
};
